module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_integration02-030f81bddedb553bdda1ec188a1f189d.png";